import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const DEFAULT_NEWS = [
    {
        id: 'default-1',
        title: "D.R.Y. Sovereignty Recognized by Global Alliances",
        date: "April 15, 2024",
        category: "Politics",
        excerpt: "The Democratic Republic of the Yoruba receives acknowledgment from international bodies following the historic proclamation.",
        authorisedBy: "Executive Office",
        createdAt: "2024-04-15T00:00:00.000Z"
    },
    {
        id: 'default-2',
        title: "Infrastructure Development Plan Unveiled",
        date: "May 10, 2024",
        category: "Development",
        excerpt: "The provisional government announces a comprehensive roadmap for rebuilding roads, power, and healthcare.",
        authorisedBy: "Executive Office",
        createdAt: "2024-05-10T00:00:00.000Z"
    },
    {
        id: 'default-3',
        title: "Cultural Renaissance Festival Announced",
        date: "May 22, 2024",
        category: "Culture",
        excerpt: "A week-long celebration of Yoruba heritage, arts, and music to take place in the capital.",
        authorisedBy: "Executive Office",
        createdAt: "2024-05-22T00:00:00.000Z"
    },
    {
        id: 'default-4',
        title: "New Education Policy for Indigenous Youths",
        date: "June 01, 2024",
        category: "Education",
        excerpt: "Free and compulsory education initiative launched to empower the next generation of leaders.",
        authorisedBy: "Executive Office",
        createdAt: "2024-06-01T00:00:00.000Z"
    }
];

export const getNews = async () => {
    try {
        const res = await axios.get(`${API_BASE_URL}/news`);
        const items = Array.isArray(res.data) ? res.data : [];
        if (!items.length) {
            return DEFAULT_NEWS;
        }
        return items;
    } catch (err) {
        console.error("Error getting news:", err);
        return DEFAULT_NEWS;
    }
};

export const saveNews = async (item) => {
    try {
        const newsItem = {
            ...item,
            featuredImage: item.featuredImage || item.image || null,
            createdAt: item.createdAt || new Date().toISOString()
        };
        
        console.log('📤 Sending news to server:', newsItem.title);
        
        let response;
        if (newsItem.id) {
            console.log('🔄 Updating existing news:', newsItem.id);
            response = await axios.put(`${API_BASE_URL}/news/${newsItem.id}`, newsItem);
        } else {
            console.log('✏️ Creating new news item');
            response = await axios.post(`${API_BASE_URL}/news`, newsItem);
        }
        
        console.log('✅ News saved, ID:', response.data._id || response.data.id);
        
        // Fetch fresh list from server
        const all = await getNews();
        console.log('📊 Updated news list count:', all.length);
        return all;
    } catch (err) {
        console.error('❌ Error saving news:', err.response?.status, err.response?.data);
        const errorMsg = err.response?.data?.message || err.message || 'Unknown error';
        throw new Error(`Failed to save news: ${errorMsg}`);
    }
};

export const deleteNews = async (id) => {
    try {
        await axios.delete(`${API_BASE_URL}/news/${id}`);
        const all = await getNews();
        return all;
    } catch (err) {
        console.error("Error deleting news:", err);
        throw err;
    }
};
